import type { Route } from 'next';
import { useIntl } from 'react-intl';

import messages from './messages';
import { RightArrow, Wrapper } from './styles';
import { PackClassLinkProps } from './types';

const PackClassLink = ({ pack, cta, theme = 'small' }: PackClassLinkProps) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper
			href={`/app/class/${pack.pack_class}` as Route}
			$theme={theme}
			aria-label={formatMessage(messages.ariaLabel, {
				title: pack.title,
			})}
		>
			{cta ?? formatMessage(messages.seeAllCta)}
			<RightArrow $theme={theme} />
		</Wrapper>
	);
};

export default PackClassLink;
